import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchElements } from "../../../Store/reducers/elementsSlice";
import AppConfig from "../../../config/AppConfig";
import mright from "../../../assets/icons/icon-mright.svg";
import { dataHandlers } from "../../../utils/objectHandlers";

const FullCategoryElements = ({ categoryId, setSelectedCategory }) => {
  const fabricCanvas = useSelector((state) => state.fabricCanvas.fabricCanvas);
  const dispatch = useDispatch();
  const selectedCategory = useSelector((state) =>
    state.elements.elements.find((cat) => cat.id === categoryId)
  );
  const observerRef = useRef(null);

  useEffect(() => {
    console.log("Category updated:", selectedCategory);
  }, [selectedCategory]);

  const [loading, setLoading] = useState(false);
  // Start with page 2 assuming initial load is page 1
  const [currentPage, setCurrentPage] = useState(2);

  useEffect(() => {
    if (
      selectedCategory &&
      (selectedCategory.nextPageUrl ||
        (selectedCategory.elements &&
          selectedCategory.elements.length > 2 &&
          !loading))
    ) {
      setLoading(true);
      dispatch(
        fetchElements({ page: currentPage, categoryId: selectedCategory.id })
      )
        .then(() => {
          setCurrentPage(1);
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    }
    
  }, [selectedCategory]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !loading) {
          setLoading(true);
          setCurrentPage((prev) => prev + 1);
        }
      },
      { threshold: 1.0 }
    );

    if (observerRef.current) {
      observer.observe(observerRef.current);
    }

    return () => {
      if (observerRef.current) {
        observer.unobserve(observerRef.current);
      }
    };
  }, [loading]);

  const handleAddElementToCanvas = (element) => {
    if (fabricCanvas) {
        const url = `${AppConfig.storageUrl}/${element.image}`;
        dataHandlers.svg(url, fabricCanvas);
      }
  };

  const handleDragStart = (e, element) => {
    const fullUrl = `${AppConfig.storageUrl}/${element.image}`;
    e.dataTransfer.setData("svg", fullUrl);
  };

  return (
    <>
      <div className="flex items-center gap-1">
        <img
          src={mright}
          alt="Back Icon"
          className="w-[20px] h-[20px] ml-2 cursor-pointer rotate-180"
          onClick={() => setSelectedCategory(null)}
        />
        <h3 className="font-semibold text-black font-montserrat text-[12px] leading-[12.19px]">
          {selectedCategory && selectedCategory.title}
        </h3>
      </div>
      <div
        className="h-[340px] overflow-y-scroll custom-scrollbar px-2"
        ref={observerRef}
      >
        <div className="elements-grid grid grid-cols-2 gap-2 p-2">
          {((selectedCategory && selectedCategory.elements) || []).map(
            (item, index) => (
              <img
                onClick={() => handleAddElementToCanvas(item)}
                onDragStart={(e) => handleDragStart(e, item)}
                key={index}
                src={`${AppConfig.storageUrl}/${item.image}`}
                className="w-[90px] h-[90px] object-cover"
                draggable
                alt="img"
              />
            )
          )}
        </div>
      </div>
    </>
  );
};

export default FullCategoryElements;
